export const formatPhoneNumber = (phone: string): string => {
  // Remove all non-numeric characters and ensure we only have digits
  const cleaned = ('' + phone).replace(/\D/g, '');
  
  // Remove leading '1' if present (USA country code)
  const withoutCountryCode = cleaned.startsWith('1') ? cleaned.slice(1) : cleaned;
  
  // Handle 10-digit phone numbers
  const match = withoutCountryCode.match(/^(\d{3})(\d{3})(\d{4})$/);
  
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  
  // If the number doesn't match the expected format but has 10 digits, format it anyway
  if (withoutCountryCode.length === 10) {
    return `${withoutCountryCode.slice(0,3)}-${withoutCountryCode.slice(3,6)}-${withoutCountryCode.slice(6)}`;
  }
  
  // Return original if format doesn't match
  return phone;
};